import React from 'react';

export const SelectOpinionMenuIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={22} fill="none" {...props}>
            <path
                fill="white"
                d="M6.518 17.776a6.483 6.483 0 0 1-4.61-1.906A6.474 6.474 0 0 1 0 11.263a6.474 6.474 0 0 1 2.18-4.866l.767.858a5.339 5.339 0 0 0-1.8 4.008c0 1.433.56 2.784 1.576 3.798a5.338 5.338 0 0 0 3.8 1.575 5.338 5.338 0 0 0 4.01-1.8l.855.766a6.476 6.476 0 0 1-4.864 2.18l-.006-.006Z"
            />
            <path
                fill="white"
                d="m16.07 8.814-5.77 6.262.843.776 5.77-6.262-.843-.776ZM8.169.772 1.918 6.627l.784.836 6.25-5.855L8.17.772Zm13.651 13.65-.767-.853c.073-.069.151-.137.224-.21a5.365 5.365 0 0 0 0-7.591c-2.063-2.063-3.395-2.984-4.313-2.984h-.014c-.81.01-1.518.75-2.591 1.867-.273.283-.561.59-.883.907l-.81-.81c.312-.311.595-.609.864-.887 1.23-1.282 2.117-2.208 3.41-2.223h.03c1.292 0 2.736.936 5.122 3.32A6.474 6.474 0 0 1 24 9.566a6.47 6.47 0 0 1-1.908 4.607c-.087.088-.18.17-.273.254v-.005Z"
            />
            <path
                fill="white"
                d="m12.652 4.763-6.21 6.634.838.783 6.21-6.634-.838-.783Zm8.635 8.593-6.094 5.97.803.818 6.094-5.97-.803-.818Z"
            />
            <path fill="white" d="M15.408 20.658a.893.893 0 1 0 0-1.785.893.893 0 0 0 0 1.785Z" />
            <path
                fill="white"
                d="M15.408 21.228a1.465 1.465 0 1 1-.006-2.93 1.465 1.465 0 0 1 .006 2.93Zm0-1.78a.316.316 0 1 0 0 .635.316.316 0 1 0 0-.634Z"
            />
        </svg>
    );
};

export default SelectOpinionMenuIcon;
